export default class CustomWorkview {
  customWorkviewId?: number | null;
  userId?: string | null;
  name?: string | null;
  configuration?: string | null;
  programView?: string | null;

  public constructor(params: CustomWorkview = {} as CustomWorkview) {
    let {
      customWorkviewId = 0,
      userId = null,
      name = null,
      configuration = null,
      programView = null,
    } = params;
    this.customWorkviewId = customWorkviewId;
    this.userId = userId;
    this.name = name;
    this.configuration = configuration;
    this.programView = programView;
  }
}
